var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOfficesNotactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-offices-notactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M27.313 8.766h-4.302c0-0.011 0.006-0.020 0.006-0.031v-1.136c0-2.377-1.932-4.31-4.308-4.31h-5.42c-2.377 0-4.31 1.934-4.31 4.31v1.135c0 0.011 0.006 0.020 0.006 0.031h-4.299c-1.755 0-3.184 1.429-3.184 3.185v13.574c0 1.758 1.429 3.186 3.184 3.186h22.628c1.756 0 3.184-1.429 3.184-3.186v-13.573c-0.001-1.756-1.429-3.185-3.185-3.185zM10.826 8.735v-1.136c0-1.359 1.105-2.464 2.464-2.464h5.42c1.358 0 2.462 1.105 2.462 2.464v1.135c0 0.011 0.006 0.020 0.006 0.031h-10.358c0-0.010 0.006-0.020 0.006-0.030zM4.687 10.612h22.628c0.738 0 1.338 0.601 1.338 1.339v1.504c-1.382 0.672-6.074 2.932-9.467 4.298v-1.278c0-0.51-0.414-0.923-0.923-0.923h-4.522c-0.51 0-0.923 0.414-0.923 0.923v1.279c-3.396-1.367-8.086-3.627-9.467-4.299v-1.504c-0.001-0.738 0.598-1.339 1.337-1.339zM17.338 17.398v2.679h-2.676v-2.679h2.676zM27.313 26.865h-22.626c-0.737 0-1.338-0.601-1.338-1.34v-10.018c2.097 1.010 6.427 3.058 9.467 4.23v1.263c0 0.51 0.414 0.923 0.923 0.923h4.522c0.51 0 0.923-0.414 0.923-0.923v-1.263c3.041-1.172 7.371-3.22 9.467-4.23v10.018c0 0.74-0.599 1.34-1.338 1.34z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOfficesNotactive);
export default __webpack_public_path__ + "static/media/icon-offices-notactive.4263f316.svg";
export { ForwardRef as ReactComponent };